export interface Dimension {
  id: string;
  name: string;
}

export interface Attribute {
  id: string;
  dimensionId: string;
  value: string;
  description: string;
}

export interface ProductDetails {
  id: string;
  type: 'charge-station' | 'powerbank';
  model: string;
  description: string;
  name: string;
  image: string;
  price: number;
  currency: string;
  socialProofImages: string[];
  recommendedProductIds: string[];
  variants?: Variant[];
}

export interface Variant {
  variantId: string;
  image?: string;
  attributeIds?: string[];
}

export type ProductVariant = ProductDetails & Variant;

export const allDimensions: Dimension[] = [{ id: 'color', name: 'Color' }];
export const allAttributes: Attribute[] = [
  { id: 'white', dimensionId: 'color', value: '#FFFFFF', description: 'White' },
  { id: 'black', dimensionId: 'color', value: '#000000', description: 'Black' },
];

export const getAttributeDescription = (attributeId: string) => {
  return allAttributes.find((attribute) => attribute.id === attributeId)?.description;
};

export const productCatalog: ProductDetails[] = [
  {
    id: '132',
    name: '5-slot charge station',
    model: 'CMini',
    description:
      '5-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    image: '/images/charge-station-mini-min.png',
    price: 300,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/mini-in-restaurant-min.png'],
    recommendedProductIds: ['133', '134', '135'],
    variants: [
      {
        variantId: '132-white',
        image: '/images/charge-station-mini-min.png',
        attributeIds: ['white'],
      },
      {
        variantId: '132-black',
        image: '/images/charge-station-mini-black-min.png',
        attributeIds: ['black'],
      },
    ],
  },
  {
    id: '133',
    name: '12-slot charge station',
    model: 'CMax',
    description:
      '12-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    image: '/images/charge-station-max-min.png',
    price: 300,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/max-in-restaurant-min.png'],
    recommendedProductIds: ['132', '134', '135'],
    variants: [
      {
        variantId: '133-white',
        attributeIds: ['white'],
        image: '/images/charge-station-max-min.png',
      },
      {
        variantId: '133-black',
        attributeIds: ['black'],
        image: '/images/charge-station-max-black-min.png',
      },
    ],
  },
  {
    id: '134',
    name: '20-slot charge station',
    image: '/images/charge-station-mega-min.png',
    model: 'CMega',
    description:
      '20-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 800,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/mega-in-hotel-lobby-min.png'],
    recommendedProductIds: ['132', '133', '135'],
    variants: [
      {
        variantId: '134-white',
        attributeIds: ['white'],
        image: '/images/charge-station-mega-min.png',
      },
      {
        variantId: '134-black',
        attributeIds: ['black'],
        image: '/images/charge-station-mega-black-min.png',
      },
    ],
  },
  {
    id: '135',
    name: '40-slot charge station',
    image: '/images/charge-station-ultra-min.png',
    model: 'CUltra',
    description:
      '40-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 1500,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/ultra-next-vending-machine-min.png'],
    recommendedProductIds: ['132', '133', '134'],
    variants: [
      {
        variantId: '135-white',
        attributeIds: ['white'],
        image: '/images/charge-station-ultra-min.png',
      },
      {
        variantId: '135-black',
        attributeIds: ['black'],
        image: '/images/charge-station-ultra-black-min.png',
      },
    ],
  },
  {
    id: '136',
    name: 'Powerbank',
    image: '/images/powerbank-white-min.png',
    model: 'ModelX',
    description:
      'Powerbank. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 100,
    type: 'powerbank',
    currency: 'GHS',
    socialProofImages: ['/images/person-using-powerbank-min.png'],
    recommendedProductIds: ['132', '133', '134', '135'],
    variants: [
      {
        variantId: '136-white',
        attributeIds: ['white'],
      },
    ],
  },
];

export function expand(products: ProductDetails[]): ProductVariant[] {
  return products.flatMap((product) => {
    return (product.variants ?? []).map((variant) => {
      return {
        ...product,
        ...variant,
        id: variant.variantId,
        image: variant.image ?? product.image,
        recommendedProductIds: (product.recommendedProductIds ?? []).map(
          (id) => `${id}-${variant.attributeIds?.join('-')}`,
        ),
      };
    });
  });
}

export const allProducts = expand(productCatalog);

export interface Range {
  id: string;
  min?: number;
  max?: number;
  label: string;
}

export const allPriceRanges: Range[] = [
  { id: 'under-100', max: 100, label: 'Under 100' },
  { id: '2', min: 100, max: 200, label: 'GHS100 - GHS200' },
  { id: 'ghs200-ghs300', min: 200, max: 300, label: 'GHS200 - GHS300' },
  { id: 'ghs300-ghs400', min: 300, max: 400, label: 'GHS300 - GHS400' },
  { id: 'above-ghs400', min: 400, label: 'Above GHS400' },
];
